import { Component, h, Prop } from '@stencil/core';


@Component({
    tag: 'lilu-footer-col',
    styleUrl: 'lilu-footer-col.scss',
    shadow: true
})
export class LiluFooterCol {

    @Prop() coulmnTitle = '';


    render() {
        return (
            <div class="footer-col">
                <div class="title">
                    <lilu-p size="size-18 lg-size-20" color="white" font="semibold">{this.coulmnTitle}</lilu-p>
                </div>
                <div class="content">
                    <slot></slot>
                </div>
            </div>
        );
    }
}
